import React from "react"
import { Link } from "react-router-dom"
import { SidebarItem, SidebarNavigationProps } from "../Sidebar/types"

export const NavItem = ({
  item,
  isCollapsed,
  sourceUrl,
}: {
  item: SidebarItem
  isCollapsed: boolean
  sourceUrl: string
}) => {
  const isActive = window.location.pathname.includes(item.href)
  return (
    <Link
      to={
        item.href.toLowerCase() === "/helpdesk" && sourceUrl
          ? { pathname: sourceUrl }
          : item.href
      }
      target={
        item.href.toLowerCase() === "/helpdesk" && sourceUrl
          ? "_blank"
          : "_self"
      }
      data-testid={`sidebar-navigation-item-${item.label}`}
      className={`flex items-center gap-3 text-foreground rounded-md px-2 py-2 text-md font-medium hover:bg-accent hover:text-primary mb-4 ${
        isCollapsed ? "justify-center" : ""
      } ${isActive ? "bg-accent text-primary" : ""}`}
    >
      <item.icon className="h-5 w-5" />
      {item.label}
    </Link>
  )
}

export const SidebarNavigation = ({
  isCollapsed,
  sidebarData,
  sourceUrl,
}: SidebarNavigationProps) => (
  <div className="flex-1 space-y-6 overflow-auto pb-2">
    <div className="px-8 pt-1">
      {sidebarData.map((item) => (
        <NavItem
          key={item.label}
          sourceUrl={sourceUrl}
          item={item}
          isCollapsed={isCollapsed}
        />
      ))}
    </div>
  </div>
)
